// src/environment-case.ts
import snakecase from "lodash.snakecase";
function environmentCase(name) {
  return snakecase(name).toUpperCase().replace(/_\d+/g, (r) => {
    return r.replace("_", "");
  });
}

// src/uint-array.ts
var dataToUint8Array = (data) => {
  const textEncoder = new TextEncoder();
  return textEncoder.encode(JSON.stringify(data));
};
var uint8ArrayToData = (data) => JSON.parse(new TextDecoder("utf-8").decode(data));

// src/pascal-case.ts
function pascalCase(s) {
  return default3(default2(s)).replace(/\s/g, "");
}

// src/date.ts
import { isValid } from "date-fns";
function getDateParts(date2) {
  const year = date2.getFullYear().toString();
  const month = (date2.getMonth() + 1).toString().padStart(2, "0");
  const day = date2.getDate().toString().padStart(2, "0");
  return { year, month, day };
}
var parseDate = (isoDate) => {
  if (!isoDate) {
    return void 0;
  }
  const parsed = new Date(isoDate);
  if (!isValid(parsed)) {
    return void 0;
  }
  return parsed;
};

// src/object.ts
import { default as lodashGet } from "lodash.get";
import isEqual from "lodash.isequal";
var mergeObjects = (initial, ...obs) => obs.reduce((acc, current) => ({ ...acc, ...current }), initial);
function toNDJson(records) {
  const data = Array.isArray(records) ? records : [records];
  return data.map((record) => JSON.stringify(record)).join("\n");
}
function encodeObject(obj) {
  const userContextString = JSON.stringify(obj).toString();
  const data = Buffer.from(userContextString).toString("base64");
  return data;
}
function decodeObject(objString) {
  const userContextString = Buffer.from(objString, "base64").toString("utf-8");
  const context = JSON.parse(userContextString);
  return context;
}
var removeUndefinedValues = (value) => JSON.parse(JSON.stringify(value));
var get = (obj, path) => {
  return lodashGet(obj, path);
};
var isPartialMatch = (a, b) => {
  const bKeys = Object.keys(b);
  return bKeys.every((key) => {
    const aValue = a[key];
    const bValue = b[key];
    return isEqual(aValue, bValue);
  });
};
function createObjectMap(items, mapper) {
  return items.reduce(
    (memo, item) => {
      const key = mapper(item);
      return {
        ...memo,
        [key]: item
      };
    },
    {}
  );
}

// src/array.ts
var limit = (count) => (_, index) => index < count;
var valsOrNone = (d) => {
  if (!d) {
    return void 0;
  }
  const comp = default4(d);
  if (comp.length > 0) {
    return comp;
  }
  return void 0;
};
var getArray = (item) => Array.isArray(item) ? item : [item];

// src/time/overlap.ts
var hasOverlap = (startA, endA, startB, endB) => {
  return endA >= startB && startA <= endB;
};
var toNumber = (val) => +val;
var getOverlap = (startA, endA, startB, endB) => {
  const overlap = hasOverlap(startA, endA, startB, endB);
  if (!overlap) {
    return void 0;
  }
  const start = startA > startB ? startA : startB;
  const end = endA < endB ? endA : endB;
  return {
    start: toNumber(start),
    end: toNumber(end)
  };
};

// src/property-formatter.ts
var isFormatterFn = (formatter2) => typeof formatter2 === "function";
var isFormatterObj = (formatter2) => typeof formatter2 === "object";
var createFormatter = (schema) => (val) => {
  const keys = Object.keys(schema);
  return keys.reduce((prev, key) => {
    const keySchema = schema[key];
    const keyVal = val[key];
    const isSchemaFn = isFormatterFn(keySchema);
    if (isSchemaFn) {
      return {
        ...prev,
        [key]: keySchema(keyVal)
      };
    }
    const isSchemaObj = isFormatterObj(keySchema);
    if (isSchemaObj) {
      return {
        ...prev,
        [key]: createFormatter(keySchema)(keyVal)
      };
    }
    return prev;
  }, val);
};

// src/formatters.ts
var trunc = Math.trunc;
var round = Math.round;
var length = (len) => (val) => val.slice(0, len);
var trim = (val) => val.trim();
var constant = (val) => () => val;
var optional = (fn) => (val) => val === void 0 ? void 0 : fn(val);
var array = (fn) => (val) => val.map(fn);
var formatter = {
  trunc,
  round,
  length,
  trim,
  constant,
  optional,
  array
};

// src/types/time.ts
import * as z from "zod";
var DateTypeSchema = z.string().or(z.number()).or(z.date());
var IntervalSchema = z.object({
  start: DateTypeSchema,
  end: DateTypeSchema
});

// src/delay.ts
var delay = async (ms) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

// src/async.ts
var resolveAsyncOptions = async (options) => {
  if (typeof options === "function") {
    return await options();
  }
  return Promise.resolve(options);
};

// src/index.ts
import { default as default5 } from "lodash.assign";
import { default as default2 } from "lodash.camelcase";
import { default as default6 } from "lodash.chunk";
import { default as default4 } from "lodash.compact";
import { default as default7 } from "lodash.concat";
import { default as default8 } from "lodash.difference";
import { default as default9 } from "lodash.differenceby";
import { default as default10 } from "lodash.differencewith";
import { default as default11 } from "lodash.fill";
import { default as default12 } from "lodash.filter";
import { default as default13 } from "lodash.find";
import { default as default14 } from "lodash.first";
import { default as default15 } from "lodash.flatten";
import { default as default16 } from "lodash.frompairs";
import { default as default17 } from "lodash.groupby";
import { default as default18 } from "lodash.has";
import { default as default19 } from "lodash.includes";
import { default as default20 } from "lodash.isarray";
import { default as default21 } from "lodash.isequal";
import { default as default22 } from "lodash.join";
import { default as default23 } from "lodash.intersection";
import { default as default24 } from "lodash.intersectionwith";
import { default as default25 } from "lodash.kebabcase";
import { default as default26 } from "lodash.last";
import { default as default27 } from "lodash.max";
import { default as default28 } from "lodash.maxby";
import { default as default29 } from "lodash.meanby";
import { default as default30 } from "lodash.memoize";
import { default as default31 } from "lodash.merge";
import { default as default32 } from "lodash.min";
import { default as default33 } from "lodash.minby";
import { default as default34 } from "lodash.omit";
import { default as default35 } from "lodash.omitby";
import { default as default36 } from "lodash.orderby";
import { default as default37 } from "lodash.padstart";
import { default as default38 } from "lodash.partial";
import { default as default39 } from "lodash.pick";
import { default as default40 } from "lodash.pickby";
import { default as default41 } from "lodash.range";
import { default as default42 } from "lodash.round";
import { default as default43 } from "lodash.set";
import { default as default44 } from "lodash.slice";
import { default as default45 } from "lodash.snakecase";
import { default as default46 } from "lodash.sortby";
import { default as default3 } from "lodash.startcase";
import { default as default47 } from "lodash.sum";
import { default as default48 } from "lodash.sumby";
import { default as default49 } from "lodash.take";
import { default as default50 } from "lodash.topairs";
import { default as default51 } from "lodash.unionby";
import { default as default52 } from "lodash.uniq";
import { default as default53 } from "lodash.uniqby";
import { default as default54 } from "lodash.upperfirst";
import { default as default55 } from "lodash.values";
import { default as default56 } from "lodash.debounce";
import { default as default57 } from "lodash.isempty";
export {
  IntervalSchema,
  default5 as assign,
  default2 as camelcase,
  default6 as chunk,
  default4 as compact,
  default7 as concat,
  createFormatter,
  createObjectMap,
  dataToUint8Array,
  default56 as debounce,
  decodeObject,
  delay,
  default8 as difference,
  default9 as differenceby,
  default10 as differencewith,
  encodeObject,
  environmentCase,
  default11 as fill,
  default12 as filter,
  default13 as find,
  default14 as first,
  default15 as flatten,
  formatter,
  default16 as frompairs,
  get,
  getArray,
  getDateParts,
  getOverlap,
  default17 as groupby,
  default18 as has,
  hasOverlap,
  default19 as includes,
  default23 as intersection,
  default24 as intersectionwith,
  isPartialMatch,
  default20 as isarray,
  default57 as isempty,
  default21 as isequal,
  default22 as join,
  default25 as kebabcase,
  default26 as last,
  limit,
  default27 as max,
  default28 as maxby,
  default29 as meanby,
  default30 as memoize,
  default31 as merge,
  mergeObjects,
  default32 as min,
  default33 as minby,
  default34 as omit,
  default35 as omitby,
  default36 as orderby,
  default37 as padstart,
  parseDate,
  default38 as partial,
  pascalCase,
  default39 as pick,
  default40 as pickby,
  default41 as range,
  removeUndefinedValues,
  resolveAsyncOptions,
  default42 as round,
  default43 as set,
  default44 as slice,
  default45 as snakecase,
  default46 as sortby,
  default3 as startcase,
  default47 as sum,
  default48 as sumby,
  default49 as take,
  toNDJson,
  default50 as topairs,
  uint8ArrayToData,
  default51 as unionby,
  default52 as uniq,
  default53 as uniqby,
  default54 as upperfirst,
  valsOrNone,
  default55 as values
};
//# sourceMappingURL=index.mjs.map